export default __webpack_public_path__ + "static/brcc-full-width-1-mobile-e174fa1bc7aa5426c29ca058dc50b205.webp";